import React from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { parseAxiosError } from "../../../utils/response";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import DefaultButton from "../../styles/materialButtonStyle";
import { StyledAbstractCommandWrapper } from "./styledSystemCommand";

const AbstractCommand = ({ notification, setNotification, commandUrl, description }) => {

  const runCommand = () => {

    axios.post("/api/system-command/" + commandUrl, {}, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setNotification({ ...notification, visible: true, type: "success", message: "Command successfully executed" });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <StyledAbstractCommandWrapper>
      <div className="command__description">
        {description}
      </div>
      <div className="command__actions">
        <DefaultButton
          onClick={runCommand}
          color="success"
        >
          Run
        </DefaultButton>
      </div>
    </StyledAbstractCommandWrapper>
  );
};

export default AbstractCommand;